import qs from "qs"

const url = "/bulletin-board"

export const search = (vueInstance, isEffective, isAnnounced, isNotifiable, isPublic, typeList, roleCodeList, unpaged, page, size, sort) => 
  vueInstance.$authHttp
    .get(`${url}/search`, {
      params: { isEffective, isAnnounced, isNotifiable, isPublic, typeList, roleCodeList, unpaged, page, size, sort },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" })
    });

/// 取得 Search list
export const get = (vueInstance, effectiveDate, isAnnounce, page, size, sort) => {
  return vueInstance.$authHttp.get(`${url}`, {
    params: { effectiveDate: effectiveDate, isAnnounce: isAnnounce, page: page, size: size, sort: sort },
  })
}

/// Upsert
export const upsert = (vueInstance, params) => vueInstance.$authHttp.post(`${url}`, params)
/// Upsert
export const announcement = (vueInstance, bulletinBoardUuid) =>
  vueInstance.$authHttp.put(`${url}/announce`, {
    bulletinBoardUuid: bulletinBoardUuid,
  })
/// Remove
export const remove = (vueInstance, bulletinBoardUuid) =>
  vueInstance.$authHttp.delete(`${url}/delete?bulletinBoardUuid=${bulletinBoardUuid}`);

export const getCurrentUserReadRecord = (vueInstance) => 
  vueInstance.$authHttp.get(`${url}/readRecord`);

export const read = (vueInstance, bulletinBoardUuidList) => 
  vueInstance.$authHttp.post(`${url}/read`, {
    bulletinBoardUuidList: bulletinBoardUuidList
  });
